export default __webpack_public_path__ + "static/media/credit-card-2.1d90c555.png";